var escape = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbody {\n  width: 100%;\n  height: 100%;\n  background: #F3F6FE;\n  background: url(" + escape(require("../assets/image/login.png")) + ") no-repeat;\n  background-size: 100% 100%;\n}\n", ""]);

// exports
